import React, { useRef, useEffect, useState } from 'react';
import { AiOutlineUpload, AiOutlineDelete } from 'react-icons/ai';
import { Form, Button, Select, Input, Upload, message, InputNumber } from 'antd';
// import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { useGlobalState } from '../../../../store/state';
import { API_FETCH } from '../../../../utils';
// import uuid from "react-uuid";
const { Option } = Select;

// @ATT:this was created to make nested dynamic elements! This is hard!
const { Item } = Form;
const { Dragger, LIST_IGNORE } = Upload;
// var flg = false;
const CampBedCreative = ({ childKey, indx, cardName, pRemove, taskTypes }) => {
  // useEffect(() => {
  //     console.log("taskTypes",taskTypes)
  // }, [])
  const [user] = useGlobalState('user');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  // const assetRefs = useRef();
  // const [flList, setFlList] = useState(create_camp_draft.deliverables.assets || [])
  // const removeFile = (file) =>{
  //     console.log("file",file)
  // }

  const uploadProps = {
    name: 'filename',
    listType: 'picture',
    FileList: 'fileList',
    // FileList: flList,
    accept: 'image/png, image/jpg, image/jpeg, application/pdf, video/mp4, application/msword',
    multiple: true,
    customRequest: function (componentsData) {
      // console.log("inputdata",componentsData)
      const formData = new FormData();
      const _reqHeader = new Headers();
      _reqHeader.append('Authorization', `Bearer ${user.accessToken}`);
      formData.append('asset', componentsData.file);
      fetch(API_FETCH(`/brand/campaign/assets/upload/${create_camp_draft.brand}/${create_camp_draft.campaignid}/image`), {
        method: 'POST',
        headers: _reqHeader,
        body: formData,
        redirect: 'follow',
      })
        .then((response) => response.json())
        .then((result) => componentsData.onSuccess(result));
    },

    onChange: function ({ file, fileList }) {
      // let fl = fileList
      // console.log("lists",fl)
      // console.log("chANGE",file)
      if (file && file.response) {
        // console.log("fl",file)
        if (file.response.status === 200 && file.status === 'done') {
          message.success(`${file.response.response.filename} Asset saved Sucessfully!`);
        } else if (file.status === 'removed') {
          message.destroy();
          message.warning(`${file.name} Asset removed!`);
        } else {}
      }

      // fileList = fl.slice(-1);
    },
    beforeUpload: (info) =>{
      if (
        info.type === 'image/png' ||
                info.type === 'image/jpg' ||
                info.type === 'image/jpeg'||
                info.type === 'video/mp4'||
                info.type === 'application/pdf' ||
                info.type === 'application/msword'
      ) {
        // message.info(`${info.name} file ready to upload!`);
        return info;
      } else {
        message.error(`${info.name} is not a supported file type`);
        return LIST_IGNORE;
      }
    },
    // itemRender:(
    //     originNode,
    //     file,
    //     fileList
    //     ) => {
    //     console.log("file", file)

    // let _orgNode = originNode;
    // _orgNode.key = Math.random() * 10000
    // let getEl = ref.current && ref.current.getElementsByClassName("ant-upload-list-picture-container")[0]
    // let _name = document.getElementsByClassName("ant-upload-list-picture-container")[0]
    // let _name = assetRefs.current && assetRefs.current.getElementsByClassName("ant-upload-list-item-name")[0]
    // if (_name) { _name.innerText = file.filename || file.name}
    // console.log("org", _name)
    //


    // if(!flg){
    //     let _new = []
    //     fileList.map((fl,i) => {
    //         let _v =  {
    //             name: fl.filename,
    //             ...fl
    //         }
    //         _new.push(_v)
    //         // let _name = ref.current && ref.current.getElementsByClassName("ant-upload-list-item-name")[0]
    //         // if (_name) { _name.innerText = file.filename || file.name}
    //     })
    //     setFlList(_new)
    // }
    // flg = true
    // return (
    //     <div className="">
    //         <span>
    //             <img src={file.url} width="40" alt="" />
    //         </span>
    //         <span>
    //             {file.name || file.filename}
    //         </span>
    //         <span onClick={() =>removeFile(file)}>
    //             remove
    //         </span>
    //     </div>
    // )
    // return (
    //     <div className="vbb">
    //          {originNode}
    //     </div>
    // )
    // }
  };
  const normFile = (e) =>{
    if (e.fileList.length > 2) {
      return [e.fileList[1], e.fileList[2]];
    } else {
      return e && e.fileList;
    }
  };
  return (
    <div key={childKey}
      className="creative_cards_each p-3  my-3">
      <h6 className="pb-2 m-0">Creative <span>#{indx}</span></h6>

      <div className="d-flex">
        <div className="col-md-5 pr-2 pl-0">
          <Item label="Asset Upload"
            // className={id}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            // onChange={uploadChange}
            initialValue={undefined}
            name={[indx, `assets`]}
            fieldKey={[indx, `assets`]}
            // rules={[{required: true}]}
          >
            <Dragger {...uploadProps}>
              <p className="text-center svg-icon">
                <AiOutlineUpload size={24} />
              </p>
              <p className="ant-upload-text"><strong>Click or Drag & Drop</strong><br/>your file here to upload</p>
              <p className="ant-upload-hint">Supports png/jpg,jpeg,pdf,doc,mp4</p>
            </Dragger>
          </Item>
        </div>
        <div className="col-md-7 p-0">
          <div className="d-flex flex-wrap">
            <div className="col-md-6 px-2">
              <Item
                label="Task type"
                name={[indx, `format`]}
                fieldKey={[indx, `format`]}
                // name={`campCreativeTaskType_${uuid}}`}
                initialValue={undefined}
                // rules={[{required: true}]}
              >
                <Select size="large"
                  placeholder="Select"
                  className="common_select">
                  {taskTypes &&
                                        taskTypes.map((task, i) =>(
                                          <Option key={`cTasks_${i}`}
                                            value={task}>{task}</Option>
                                        ))
                  }
                  {/* <Option value="Static Post">Static Post</Option> */}
                  {/* <Option value="Story">Story</Option> */}
                </Select>
              </Item>
            </div>
            <div className="col-md-6 pl-2 pr-0">
              <Item
                label="No. of Posts (max: 10)"
                name={[indx, `creatives`]}
                fieldKey={[indx, `creatives`]}
                // rules={[{maxlength:10,message:"maximum allowed posts count is 10"}]}
              >
                {/* <Input
                                    className="common_input"
                                    size="large"
                                    placeholder="Eg:10"
                                    type="number"
                                    maxLength={10}
                                /> */}
                <InputNumber
                  className="common_input overflow-hidden"
                  style={{ width: '100%' }}
                  size="large"
                  placeholder="Eg:10"
                  type="number"
                  min={1}
                  max={10}
                />
              </Item>
            </div>
            <div className="col-md-12 p-0 text-right">
              <Button className="common_button outlined py-1 mr-2"
                onClick={() => pRemove(cardName)}>DELETE</Button>
              {/* <Button
                                className="common_button outlined py-1"
                            >SAVE</Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampBedCreative;
